export interface AiCaptainTableItem {
  id: number;
  tableNumber: number;
  tableName?: string;
  totalSeats?: number;
  locationId?: number;
  locationName?: string;
  smokingAllowed?: boolean;
  canSelect?: boolean;
  spaceType?: 'TABLE' | 'ROOM';
  spaceNoun?: string;
  displayLabel?: string;
}

export interface AiCaptainTableStatus {
  requestId?: number;
  tableId?: number;
  tableNumber?: number;
  allotted?: boolean;
  active?: boolean;
  spaceType?: 'TABLE' | 'ROOM';
  spaceNoun?: string;
  displayLabel?: string;
}

export interface AiCaptainPlacedOrder {
  orderId?: number;
  orderCode?: string;
  orderStatus?: string;
  estimatedPrepMinutes?: number;
  orderType?: number;
  message?: string;
}

export function normalizeAiCaptainTable(raw: Record<string, unknown>): AiCaptainTableItem {
  const spaceType = raw.spaceType === 'ROOM' ? 'ROOM' : raw.spaceType === 'TABLE' ? 'TABLE' : undefined;
  return {
    id: Number(raw.id),
    tableNumber: Number(raw.tableNumber ?? 0),
    tableName: raw.tableName ? String(raw.tableName) : undefined,
    totalSeats: raw.totalSeats != null ? Number(raw.totalSeats) : undefined,
    locationId: raw.locationId != null ? Number(raw.locationId) : undefined,
    locationName: raw.locationName ? String(raw.locationName) : undefined,
    smokingAllowed: raw.smokingAllowed === true,
    canSelect: raw.canSelect !== false,
    spaceType,
    spaceNoun: raw.spaceNoun ? String(raw.spaceNoun) : undefined,
    displayLabel: raw.displayLabel ? String(raw.displayLabel) : undefined,
  };
}

export function normalizeAiCaptainTableStatus(raw: Record<string, unknown>): AiCaptainTableStatus {
  const spaceType = raw.spaceType === 'ROOM' ? 'ROOM' : raw.spaceType === 'TABLE' ? 'TABLE' : undefined;
  return {
    requestId: raw.requestId != null ? Number(raw.requestId) : undefined,
    tableId: raw.tableId != null ? Number(raw.tableId) : undefined,
    tableNumber: raw.tableNumber != null ? Number(raw.tableNumber) : undefined,
    allotted: raw.allotted === true,
    active: raw.active !== false,
    spaceType,
    spaceNoun: raw.spaceNoun ? String(raw.spaceNoun) : undefined,
    displayLabel: raw.displayLabel ? String(raw.displayLabel) : undefined,
  };
}

export function formatTableLabel(table: AiCaptainTableItem): string {
  const noun = table.spaceNoun || (table.spaceType === 'ROOM' ? 'Room' : 'Table');
  const fallback = table.displayLabel || `${noun} ${table.tableNumber}`;
  const rawName = table.tableName?.trim();
  const name =
    rawName && rawName !== 'N/A' && rawName !== String(table.tableNumber) && rawName !== fallback
      ? rawName
      : fallback;
  const seats = table.totalSeats ? ` · ${table.totalSeats} seats` : '';
  const zone = table.locationName ? ` · ${table.locationName}` : '';
  const smoking = table.smokingAllowed ? ' · Smoking' : ' · Non-smoking';
  return `${name}${seats}${zone}${smoking}`;
}
